import React from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { studentColumns } from '../../Data/StudentManagement/StudentListData'
import { getAllData } from '../../lib/studentinfo'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminStudentList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const { data: students, loading, searchQuery, setSearchQuery } = useDataManagement(getAllData)

	// Sort students by name
	const sortedStudents = React.useMemo(() => {
		return [...students].sort((a, b) => {
			const nameA = a.name ? a.name : ''
			const nameB = b.name ? b.name : ''
			return nameA.localeCompare(nameB)
		})
	}, [students])

	return (
		<DataManagementGrid
			title="Student List"
			subTitle="Manage all students in the system"
			breadcrumbTitle="Student Management"
			breadcrumbMainTitle="Student Management"
			columns={(layout, role) => studentColumns(layout, role)}
			data={sortedStudents}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search by name, school, grade, or status..."
			createButtonText="Create New Student"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/students/create/${layout}`}
			searchFields={['name', 'surname', 'schoolname', 'class', 'isActive']}
			noDataMessage="No students found"
		/>
	)
}

export { AdminStudentList }
